<template>
  <div class="information">
    <!--<van-nav-bar title="个人信息" left-arrow @click-left="onClickLeft" border/>-->
    <!--<label class="head-img-con" for="headFile">
      <van-cell title="头像" is-link>
        <img class="head-img" :src="avatar" alt="">
      </van-cell>
      <input id="headFile" ref="headFile" class="headFile" type="file">
    </label>-->
    <!--<van-uploader class="van-uploader-width-100" accept="image/*" :max-size="1024 * 1024 * fileSize"
                  :after-read="onRead" @oversize="oversize" disabled >
      <van-cell class="avatar-con" title="头像" is-link @click="showMyAvatar(avatar)">
        <img class="head-img" :src="avatar+'?imageView2/0/w/100/h/100'" alt="">
      </van-cell>
    </van-uploader>-->
    <van-cell class="avatar-con" title="头像" is-link @click="showMyAvatar(avatar ? checkQiNiuUrl(avatar) : '/image/avatar.png')">
      <img class="head-img" :src="avatar ? (checkQiNiuUrl(avatar)+'?imageView2/0/w/100/h/100') : '/image/avatar.png'" alt="">
    </van-cell>

    <!--<label class="avatar-top" @click="selectImg">
      <input ref="fileInput" id="fileInput" class="fileInput" type="file">
    </label>-->

    <van-cell title="我的昵称" :value="nickname" @click="nicknameShow=true" is-link />
    <van-cell title="云柑社区号" :value="username" @click="usernameShow=true" is-link />

    <van-cell title="我的二维码" @click="goQRCode" is-link>
      <img class="qr-code" :src="checkQiNiuUrl('FkKEOmq5kXQWHF-pINqy-0MnJac4')" alt="二维码">
    </van-cell>
    <van-cell title="更多" @click="goInformationMore" is-link />

    <div class="bg-10px"></div>
    <van-cell title="收货地址" is-link @click="goReceivingAddress" />


    <van-popup v-model="nicknameShow" position="bottom" class="popup-top0">
      <van-nav-bar
          title="设置昵称"
          left-text="取消"
          right-text="保存"
          :left-arrow="false"
          @click-left="cancelNickname"
          @click-right="saveNickname"
      />
      <van-form
          ref="form1"
      >
        <van-field
            v-model="nickname"
            clearable
            maxLength="20"
            placeholder="请输入昵称"
            :rules="[{required: true, message: '请输入昵称'}]"
        >
        </van-field>
      </van-form>
    </van-popup>

    <van-popup v-model="usernameShow" position="bottom" class="popup-top0">
      <van-nav-bar
          title="设置云柑社区号"
          left-text="取消"
          right-text="保存"
          :left-arrow="false"
          @click-left="cancelUsername"
          @click-right="saveUsername"
      />
      <van-form
          ref="form2"
      >
        <van-field
            v-model="username"
            clearable
            maxLength="20"
            placeholder="请输入报信号"
            :rules="[{required: true, message: '请输入报信号'},{pattern: /^[0-9a-zA-Z]{6,20}$/, message: '仅支持长度为 6-20 位的字母、数字组合'}]"
        >
        </van-field>
      </van-form>
    </van-popup>

    <wx-config/>
  </div>
</template>

<script>
// import { address, addressList } from '@/api/my/address'
import wxConfig from '@/components/weixin/wxConfig'
import { updateUser } from '@/api/my'
export default {
  components: {
    wxConfig,
  },
  data() {
    return {
      fileSize: 5, //图片文件大小限制，单位Mb

      //头像
      avatar: this.session('user').avatar || '',

      //邀请码
      inviteCode: this.session('user').inviteCode,

      // 昵称
      nickname: this.session('user').nickname,
      nicknameShow: false,

      // 报信号
      username: this.session('user').username,
      usernameShow: false,
    }
  },
  computed: {

  },
  created() {
    // this.getaddr()
    console.log(this.$refs)
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    goQRCode() {
      this.$router.push({ name: 'QRCode', params:{ inviteCode: this.inviteCode } })
    },
    goInformationMore() {
      this.$router.push({ name: 'informationMore' })
    },
    goReceivingAddress() {
      this.$router.push({ name: 'addressList' })
    },


    // 昵称 nickname
    cancelNickname() {
      this.nickname = this.session('user').nickname
      this.nicknameShow = false
    },
    saveNickname() {
      this.$refs['form1'].validate().then(()=>{
        updateUser({nickname: this.nickname,openid: this.session('userOpenId')}).then(res=>{
          if(res.code===200){
            this.$toast('修改成功！')
            this.nicknameShow = false
          }else {
            this.$toast(res.message)
          }
        })
      })

    },
    // 报信号 username
    cancelUsername() {
      this.username = this.session('user').username
      this.usernameShow = false
    },
    saveUsername() {
      this.$refs['form2'].validate().then(()=>{
        updateUser({username: this.username, openid: this.session('userOpenId')}).then(res=>{
          if(res.code===200){
            this.$toast('修改成功！')
            this.usernameShow = false
          }else {
            this.username = this.session('user').username;
            this.$toast(res.message)
          }
        })
      })
    },

    onRead(file) {
      console.log(file)
    },
    oversize(file){
      this.$toast(`图片不能超过 ${this.fileSize} Mb`)
    },

    showMyAvatar(url){
      // console.log(url)
      if(url){
        this.showImagePreview({ images: [url], startPosition: 0 })
      }
    },

    selectImg(){
      console.log(111)
      // wx.chooseImage({
      //   count: 1, // 默认9
      //   sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
      //   sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
      //   success: function (res) {
      //     let localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
      //     console.log(localIds)
      //     wx.getLocalImgData({
      //       localId: [localIds][0], // 图片的localID
      //       success: function (res) {
      //         let localData = res.localData; // localData是图片的base64数据，可以用img标签显示
      //         console.log(localData)
      //       }
      //     });
      //   }
      // });
    },





    // getaddr(){
    //   address(this.userInfo.id).then(res=>{
    //     console.log(1)
    //     console.log(res)
    //   })
    //   addressList(this.userInfo.id).then(res=>{
    //     console.log(2)
    //     console.log(res)
    //   })
    //
    // }
  }
}
</script>

<style lang="less" scoped>
.information{
  position: relative;
  /*.head-img-con{
    .head-img{
      font-size: 12px;
      width: 46px;
      height: 46px;
      border-radius: 50%;
      vertical-align: middle;
    }
    .headFile{width: 0;height: 0;opacity: 0;}
    .van-cell__right-icon{
      line-height: 46px;
    }
  }*/

  .avatar-top{
    display: none;
    background-color: rgba(255,200,200,.5);
    position: absolute;z-index: 1;
    top: 0;left: 0;
    width: 100%;
    height: 66px;
    .fileInput{
      display: none;
    }
  }

  .van-uploader-width-100{width: 100%;}
  .head-img{
    font-size: 12px;
    width: 46px;
    height: 46px;
    border-radius: 50%;
    vertical-align: middle;
  }
  .qr-code{
    width: 22px;
    height: 22px;
  }

}
</style>
<style lang="less">
.van-uploader-width-100{
  .van-uploader__input-wrapper{
    width: 100%;
  }
}
.information{
  .avatar-con{
    .van-cell__title, .van-cell__right-icon{
      line-height: 46px;
    }
  }
}
</style>